// src/components/Seo/Seo.js
import React from 'react';
import { Helmet } from 'react-helmet';

export default function Seo({
  title,
  description,
  canonicalUrl,
  ogImageUrl,
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description"    content={description} />
      <link rel="canonical"       href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type"        content="website" />
      <meta property="og:url"         content={canonicalUrl} />
      <meta property="og:title"       content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image"       content={ogImageUrl} />

      {/* Twitter */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:url"         content={canonicalUrl} />
      <meta name="twitter:title"       content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={ogImageUrl} />
    </Helmet>
  );
}

Seo.defaultProps = {
  title:        'Ques | Q&A Platform for Businesses and Professionals',
  description:  'Your personal FAQ. Let fans and customers ask you directly, once — and never repeat yourself again.',
  canonicalUrl: 'https://askques.com/',
  ogImageUrl:   'https://askques.com/images/og-image.png',
};
